import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { globalFaqs } from "../data/mock";

const FAQSection = () => {
  return (
    <section id="faq" className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-10 scroll-mt-24">
      <h2 className="text-2xl font-extrabold text-[#111827] mb-1">Frequently Asked Questions</h2>
      <p className="text-slate-500 text-sm mb-6">Common questions about source status, withheld scores and the 55-criterion register.</p>
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm px-6">
        <Accordion type="single" collapsible className="w-full">
          {globalFaqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left font-semibold text-[#111827] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
